import React, { useRef, useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

// File Upload
import FileUpload from '../../Form/components/FileUpload';
import { Loader } from 'lucide-react';

// config file
const BulkUploadModal = (props) => {
    const [clickCount, setClickCount] = useState(0);
    const fileUploadRef = useRef();
    const [loading, setIsLoading] = useState(false);

    /**@FileName Extraction */
    let filename = props.sampleFilePath.split("/").slice(-1)[0]

    const uploadToServer = () => {
        setIsLoading(true);
        if (clickCount == 0) {
            fileUploadRef.current.UploadFileToServer();
        }
    }

    const handleClickCount = () => {
        setClickCount(0);
    }


    const { t } = props;

    return (
        <Modal isOpen={props.openBulkUploadModal}
            className={`modal-dialog-centered modal-dialog--primary modal-dialog--header `}>
            <ModalHeader className="modal__header">
                <button className="lnr lnr-cross modal__close-btn" type="button"
                    onClick={() => props.closeBulkModal() && props.reload()} />
                <p className="bold-text  modal__title"> {'Bulk Upload'} </p>
            </ModalHeader>
            <ModalBody>
                {loading && (
                    <div className="bulk-loader-overlay">
                        <div className="bulk-loader-content">
                            <Loader className="rotate-loader animate-spin" size={42} />
                            <p className="mt-3">Uploading... Please wait</p>
                        </div>
                    </div>
                )}
                {props.type != "companyData" && <div className='row'>
                    <div className='col-5'>
                        {'Sample Document'}
                    </div>
                    <div className='col-7'>
                        <a className='btn btn-primary outline text-white' href={props.sampleFilePath} download={filename}>Download</a>
                    </div>
                </div>}
                <div className='row'>
                    <div className='col-5'>
                        {'Please Attach File'}
                    </div>
                    <div className='col-7'>
                        <FileUpload type="bulkUpload"
                            ref={fileUploadRef}
                            url={props.type}
                            close={props.closeBulkModal}
                            reload={props.reload}
                            setAllUsersData={props.setAllUsersData}
                            setExcelDownloadPath={props.setExcelDownloadPath}
                            setIsLoading={setIsLoading}
                        />
                    </div>
                </div>
                <div className='row mt-5'>
                    <div className='col-sm-12 text-center'>
                        <Button color='primary' outline
                            onClick={() => props.closeBulkModal() && reload()}>{'Close'}</Button>
                        <Button color='primary'
                            disabled={loading}
                            onClick={uploadToServer}>{'Upload'} - {props.type}</Button>
                    </div>
                </div>
            </ModalBody>

        </Modal >
    );

}

export default BulkUploadModal;